<div class="container-box">
  <h1>Thank You for Shopping with AT&amp;T</h1>
  <section class="shadowbox">
  <div class="step-confirmation">
    <i class="icon-controls-approvalL"></i>
    <h3 class="orderConfirmtest">Order Successful</h3>
    <div class="clearfix"></div>
    <article>
      <p>Thank you for your purchase. You will receive an email shortly to confirm your order at {{email}}. </p>
      <p>Order ID: {{id}} </p>
    </article>
    <div class="text-right"><button class="btn btn-secondary" (click)="onOrderComplete()">Done</button></div>
  </div>
  </section>
</div>
